import { render, staticRenderFns } from "./CreateTable.vue?vue&type=template&id=8f8606e8&scoped=true"
import script from "./CreateTable.vue?vue&type=script&lang=js"
export * from "./CreateTable.vue?vue&type=script&lang=js"
import style0 from "./CreateTable.vue?vue&type=style&index=0&id=8f8606e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8606e8",
  null
  
)

export default component.exports